import { render, staticRenderFns } from "./MedicalCalendar.vue?vue&type=template&id=224f2000"
import script from "./MedicalCalendar.vue?vue&type=script&lang=js"
export * from "./MedicalCalendar.vue?vue&type=script&lang=js"
import style0 from "./MedicalCalendar.vue?vue&type=style&index=0&id=224f2000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports